function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { SessionSelectors } from 'invision-core';
import { PageDataSelector } from '../../../reducers/selectors/custom.page.selectors';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
var CustomPageContextualController = /*#__PURE__*/function () {
  function CustomPageContextualController($ngRedux) {
    _classCallCheck(this, CustomPageContextualController);
    Object.assign(this, {
      $ngRedux: $ngRedux
    });
  }
  return _createClass(CustomPageContextualController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomer: CurrentCustomerSelector(store),
          currentUserContext: SessionSelectors.UserSecurityContextSelector(store),
          pageData: PageDataSelector(store),
          templateLoaded: MetadataCodeLoadedSelector(CODES.BusinessUnitTemplate, store)
        };
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget)(function (state) {
        _this.state = state;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }]);
}();
export default {
  template: require('./custom.page.contextual.html'),
  controller: CustomPageContextualController
};